import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import ErrorHandler from '../ErrorHandler/ErrorHandler';
import SortButton from './SortButton';

const pageSpinner = require('../../resource/img/page-loading.gif');

interface TableProps {
    header?: any[],
    rows: any[],
    clickable: boolean,
    noRecords?: string,
    sortBy?: string,
    clickSort?: (sortBy: string) => void
}

interface TableState {
    loading: boolean,
    connected: boolean
}

class Table extends React.Component <TableProps, TableState> {
    public constructor(props: TableProps) {
        super(props);
        this.state = {
            loading: true,
            connected: true
        };
        this.onError = this.onError.bind(this);
    }

    public componentWillReceiveProps(nextProps: TableProps) {
        if (nextProps.rows !== this.props.rows) {
            this.setLoading(!nextProps.rows);
        }
    }

    public setLoading(loading: boolean) {
        this.setState({loading});
    }

    public getHeader() {
        let header = [];
        for (let i = 0; i < this.props.header.length; i++) {
            const headerItem = this.props.header[i];
            header.push(
                <Grid key={i} className="cmTableViewHeaderCol" item xs={headerItem.cols}>
                    <div className={`cmTableViewHeaderContainer${this.props.sortBy && this.props.sortBy === headerItem.sortBy ? " cmTableViewHeaderContainerFocused" : ""}`}>
                        <div className="cmTableViewHeaderTitle">{headerItem.title}</div>
                        {headerItem.sortBy && <SortButton clickSort={() => this.props.clickSort(headerItem.sortBy)} isFocused={this.props.sortBy === headerItem.sortBy}/>}
                    </div>
                </Grid>
            );
        }
        return (
            <div className="cmTableViewHeader">{header}</div>
        );
    }

    public getRows() {
        let rows = [];
        for (let i = 0; i < this.props.rows.length; i++) {
            const data = this.props.rows[i];
            let row = [];
            for (let j = 0; j < this.props.header.length; j++) {
                row.push(
                    <Grid key={j} className="cmTableViewCol" item xs={this.props.header[j].cols}>
                        <div className="cmTableViewCellData">{data[j]}</div>
                    </Grid>
                );
            }
            rows.push(<div key={i} className={`cmTableViewCell cmText${this.props.clickable ? " cmClickable" : ""}`}>{row}</div>);
        }
        return rows;
    }

    public onError() {
        this.setLoading(false);
        this.setState({connected: false});
    }

    public render() {
        return (
            <div>
                <ErrorHandler onError={this.onError} displayAtCenter={true}/>
                {this.state.loading ?
                    <img className="cmCenter" src={pageSpinner}/> :
                    (this.props.rows.length ?
                        <div>
                            {this.getHeader()}
                            {this.getRows()}
                        </div> :
                        (this.state.connected && <div className="cmText noRecordsInfo">{this.props.noRecords}</div>))}
            </div>
        );
    }
}

export default Table;



// WEBPACK FOOTER //
// ./src/Components/Custom/Table.tsx